import { useCan } from "components";
import { useTypedQuery } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { TyreGroupQueryKeys } from "modules/AppointmentDetails/components/VehicleTyres/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { DealerLocation, TyreDiscount } from "models";

const selectTyreDiscountOptions = (discounts: TyreDiscount[]) =>
  discounts.reduce<DropdownItemProps[]>((options, discount) => {
    if (discount.active) options.push({ key: discount.id, value: discount.id, text: discount.name });
    return options;
  }, []);

const selectTyreDiscounts = (discounts: TyreDiscount[]) => discounts.filter(d => d.active);

const useInternalPermanentTyreDiscounts = <T>(location: DealerLocation | undefined, select: (discounts: TyreDiscount[]) => T) => {
  const canListTyreDiscounts = useCan(ACL_ACTIVITIES.List, ACL_RESOURCES.TyreDiscounts);

  return useTypedQuery({
    queryKey: TyreGroupQueryKeys.discounts(location?.dealer_id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.tyre_discounts,
    enabled: canListTyreDiscounts && location !== undefined,
    select
  });
};

export const usePermanentTyreDiscounts = (location: DealerLocation | undefined) => useInternalPermanentTyreDiscounts(location, selectTyreDiscounts);

export const usePermanentTyreDiscountOptions = (location: DealerLocation | undefined) => useInternalPermanentTyreDiscounts(location, selectTyreDiscountOptions);
